var _require = require('./USFMparser'),
    USFMParser = _require.USFMParser;

var _require2 = require('./JSONparser'),
    JSONParser = _require2.JSONParser;

var _require3 = require('../schemas/file'),
    JSONSchemaDefinition = _require3.JSONSchemaDefinition;

var FILTER = {
  SCRIPTURE: 'clean',
  ALL: 'normal'
};
var LEVEL = {
  RELAXED: 'relaxed',
  STRICT: 'normal'
};
exports.FILTER = FILTER;
exports.LEVEL = LEVEL;
exports.USFMParser = USFMParser;
exports.JSONParser = JSONParser;
exports.JSONSchemaDefinition = JSONSchemaDefinition;